import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@mui/material';
import Chip from '@mui/material/Chip';
import TimerIcon from '@mui/icons-material/Timer';
import WorkflowGraphContainer from './WorkflowGraphContainer';
import { Card, Typography } from '@totalsoft/rocket-ui';
import { WorkflowAccordion, WorkflowSummaryContainer, WorkflowsContainer } from './WorkflowStyles';

const WorkflowInfo = ({ workflows, hasRightToViewWorkflow, hasRightToEditWorkflow, actions }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState([]);

  const getColor = status => {
    switch (status) {
      case 'COMPLETED':
        return 'primary';
      case 'FAILED':
        return 'red';
      default:
        return 'default';
    }
  };
  const handleExpand = workflowId => (event, value) => {
    const index = expanded.findIndex(a => a.workflowId === workflowId);
    const newVal = Object.assign({}, { workflowId, value });

    if (index === -1) {
      setExpanded([...expanded, newVal]);
    } else {
      setExpanded([...expanded.slice(0, index), newVal, ...expanded.slice(index + 1)]);
    }
  };

  const getFlowName = description => {
    try {
      const desc = JSON.parse(description);
      return desc.description;
    } catch {
      return description;
    }
  };

  return (
    <React.Fragment>
      <Card>
        <WorkflowsContainer>
          {hasRightToViewWorkflow &&
            workflows
              .filter(a => a.parentWorkflowId === null)
              .sort((a, b) => a.startTime - b.startTime)
              .map(flow => {
                const showD3 = expanded.find(a => a.workflowId === flow.workflowId && a.value);
                const time = ((flow.endTime > 0 ? flow.endTime : flow.updateTime) - flow.startTime) / 1000;
                return (
                  <React.Fragment key={flow.workflowId}>
                    <WorkflowAccordion
                      expanded={expanded[flow.workflowId]}
                      onChange={handleExpand(flow.workflowId)}
                      title={
                        <WorkflowSummaryContainer>
                          <Typography variant='subtitle2' fontWeight='bold'>
                            {getFlowName(flow.workflowDefinition.description)}
                          </Typography>
                          <Chip
                            variant='outlined'
                            label={flow.status}
                            style={{ color: getColor(flow.status), border: `1px solid ${getColor(flow.status)}` }}
                          />
                          <Chip variant='outlined' label={t('LONG_DATE', { date: flow.startTime })} />
                          <Chip
                            variant='outlined'
                            avatar={
                              <Avatar>
                                <TimerIcon />
                              </Avatar>
                            }
                            label={time + 's'}
                          />
                        </WorkflowSummaryContainer>
                      }
                      content={
                        <React.Fragment>
                          {showD3 && (
                            <WorkflowGraphContainer
                              flow={flow}
                              workflows={workflows}
                              hasRightToEditWorkflow={hasRightToEditWorkflow}
                              actions={actions}
                            />
                          )}
                        </React.Fragment>
                      }
                    />
                  </React.Fragment>
                );
              })}
        </WorkflowsContainer>
      </Card>
    </React.Fragment>
  );
};

WorkflowInfo.propTypes = {
  workflows: PropTypes.array.isRequired,
  actions: PropTypes.object,
  hasRightToEditWorkflow: PropTypes.bool.isRequired,
  hasRightToViewWorkflow: PropTypes.bool.isRequired
};

export default WorkflowInfo;
